import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import {
  desktopNotificationPermission,
  enableDesktopNotifications
} from 'util/desktopNotifications';

export default function DesktopNotificationControl() {
  const [permission, setPermission] = useState(desktopNotificationPermission);
  const [error, setError] = useState('');
  useEffect(() => {
    const refresh = () => setPermission(desktopNotificationPermission());
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, []);
  const enable = async () => {
    setError('');
    try {
      setPermission(await enableDesktopNotifications());
    } catch {
      setError(
        'Unable to enable desktop notifications. Check your browser settings.'
      );
    }
  };
  return (
    <div className="fs--1" aria-live="polite">
      {permission === 'default' && (
        <Button variant="outline-primary" size="sm" onClick={enable}>
          Enable desktop notifications
        </Button>
      )}
      {permission === 'granted' && (
        <span className="text-muted">Desktop notifications are enabled.</span>
      )}
      {permission === 'denied' && (
        <span>
          Desktop notifications are blocked. Allow notifications for Jurat in
          your browser settings.
        </span>
      )}
      {permission === 'insecure' && (
        <span>Open Jurat over HTTPS to enable desktop notifications.</span>
      )}
      {permission === 'unsupported' && (
        <span>
          This browser does not support desktop notifications. You can still
          read notifications here.
        </span>
      )}
      {error && (
        <p className="text-danger mb-0" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
